export default "__VITE_ASSET__ea4d66a5__"